import { combineReducers } from 'redux';
import { authReducer  } from './index';

export const rootReducer = combineReducers({
  auth: authReducer,
});